module.exports = __webpack_public_path__ + "static/img/consultEmpty.7e75f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consultEmpty.png
// module id = Jqow
// module chunks = 1